import { render } from "./FromNow.vue?vue&type=template&id=4a28ce70&ts=true"
import script from "./FromNow.vue?vue&type=script&lang=ts"
export * from "./FromNow.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__